import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './layout/AdminLayout';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import AddStudent from './pages/AddStudent';
import EditStudent from './pages/EditStudent';
import Teachers from './pages/Teachers';
import AddTeacher from './pages/AddTeacher';
import EditTeacher from './pages/EditTeacher';
import Courses from './pages/Courses';
import AddCourse from './pages/AddCourse';
import EditCourse from './pages/EditCourse';
import Batches from './pages/Batches';
import AddBatch from './pages/AddBatch';
import EditBatch from './pages/EditBatch';
import Assignments from './pages/Assignments';
import LiveClasses from './pages/LiveClasses';
import Payments from './pages/Payments';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import UnpaidStudents from './pages/UnpaidStudents';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './AuthContext';
import './App.css';

function RequireAuth({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-auth-loading" role="status" aria-live="polite">
        <img
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt="Edu Pravahaa"
          className="app-auth-loading-logo"
        />
        <div className="app-auth-loading-spinner" aria-hidden />
        <span>Loading session…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="students" element={<Students />} />
            <Route path="students/add" element={<AddStudent />} />
            <Route path="students/edit/:id" element={<EditStudent />} />
            <Route path="students/unpaid" element={<UnpaidStudents />} />
            <Route path="teachers" element={<Teachers />} />
            <Route path="teachers/add" element={<AddTeacher />} />
            <Route path="teachers/edit/:id" element={<EditTeacher />} />
            <Route path="courses" element={<Courses />} />
            <Route path="courses/add" element={<AddCourse />} />
            <Route path="courses/edit/:id" element={<EditCourse />} />
            <Route path="batches" element={<Batches />} />
            <Route path="batches/add" element={<AddBatch />} />
            <Route path="batches/edit/:id" element={<EditBatch />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="live-classes" element={<LiveClasses />} />
            <Route path="payments" element={<Payments />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
